var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsThreeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99805 10.9355C10.5158 10.9355 10.9355 10.5158 10.9355 9.99805C10.9355 9.48028 10.5158 9.06055 9.99805 9.06055C9.48028 9.06055 9.06055 9.48028 9.06055 9.99805C9.06055 10.5158 9.48028 10.9355 9.99805 10.9355Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.9355C14.2678 10.9355 14.6875 10.5158 14.6875 9.99805C14.6875 9.48028 14.2678 9.06055 13.75 9.06055C13.2322 9.06055 12.8125 9.48028 12.8125 9.99805C12.8125 10.5158 13.2322 10.9355 13.75 10.9355Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.9355C6.76777 10.9355 7.1875 10.5158 7.1875 9.99805C7.1875 9.48028 6.76777 9.06055 6.25 9.06055C5.73223 9.06055 5.3125 9.48028 5.3125 9.99805C5.3125 10.5158 5.73223 10.9355 6.25 10.9355Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsThreeCircle);
export default __webpack_public_path__ + "static/media/dots-three-circle.ee3c00c18909feeac6b74691d75908a7.svg";
export { ForwardRef as ReactComponent };